import React, { Component } from "react";
import styles from "./styles/KingstonConnect.scss";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faAddressCard,
	faUserPlus,
	faUsers,
	faUserTag
} from "@fortawesome/free-solid-svg-icons";
import BackToDashboard from "./BackToDashboard";
import { Link } from "react-router-dom";
import SignIn from "./SignIn";
import SignUp from "./SignUp";
import Modal from "react-modal";
import axios from "axios";

const customStyles = {
	content: {
		top: "50%",
		left: "50%",
		right: "auto",
		bottom: "auto",
		marginRight: "-50%",
		transform: "translate(-50%, -50%)"
	}
};

export default class KingstonConnect extends Component {
	constructor(props) {
		super(props);
		this.state = {
			loggedIn: sessionStorage.getItem("loggedIn"),
			employerId: sessionStorage.getItem("employer"),
			employerName: sessionStorage.getItem("name"),
			modalIsOpen: false,
			nomEmail: undefined,
			errorMsg: undefined,
			successMsg: undefined
		};
	}

	openModal = () => {
		this.setState({
			modalIsOpen: true
		});
	};

	afterOpenModal = () => {};

	closeModal = () => {
		this.setState({
			modalIsOpen: false
		});
	};

	handleChange = e => {
		this.setState({
			[e.target.name]: e.target.value,
			errorMsg: undefined,
			successMsg: undefined
		});
	};

	logOut = () => {
		sessionStorage.setItem("employer", undefined);
		sessionStorage.setItem("name", undefined);
		sessionStorage.setItem("loggedIn", false);
		setTimeout(() => {
			window.location.href = "/kingstonhome";
		}, 500);
	};

	resendInvite = e => {
		e.preventDefault();
		if (!this.state.nomEmail) {
			this.setState({
				errorMsg: "You must enter your email"
			});
			return;
		}
		axios
			.post("/api/kingstonconnect/resendinvite", {
				email: this.state.nomEmail
			})
			.then(res => {
				if (res.data.success === false) {
					this.setState({ errorMsg: res.data.message });
				}
				if (res.data.success === true) {
					this.setState({
						successMsg: "Confirmation Email has been sent"
					});
				}
			})
			.catch(err => {
				console.log("Error:", err);
			});
	};

	render() {
		if (this.state.loggedIn === "false" || !this.state.employerId) {
			return (
				<div className={styles.page}>
					<BackToDashboard page={"home"} />

					<div className="row col-sm-12">
						<div className="col-lg-6">
							<h2>
								{" "}
								Login to access{" "}
								<strong>
									Kingston
									<span style={{ color: "#007D99" }}>
										Connect
									</span>
								</strong>
							</h2>
							<SignIn
								login={this.login}
								setLoading={this.setLoading}
								unsetLoading={this.unsetLoading}
							/>
							<a className="nav-link" onClick={this.openModal}>Already nominated? Click here to update your profile.</a>
							<div>
								<Modal
									isOpen={this.state.modalIsOpen}
									onAfterOpen={this.afterOpenModal}
									onRequestClose={this.closeModal}
									style={customStyles}
									ariaHideApp={false}
								>
									<form>
										<div className="form-group">
											<h5>
												{" "}
												<b>Enter your email to resend invite</b>
											</h5>
											<div>
												<input
													className="form-control"
													onChange={this.handleChange}
													required
													name="nomEmail"
													type="email"
													placeholder="Email"
												/>
											</div>
											<br />
											<div className="row justify-content-center">
												<button
													className="btn btn-primary col-lg-4 mx-2"
													type="submit"
													onClick={e => this.resendInvite(e)}
												>
													Submit
												</button>
												<button
													className="btn btn-primary col-lg-4 mx-2"
													onClick={this.closeModal}
												>
													{" "}
													Cancel{" "}
												</button>
											</div>
										</div>
										{this.state.errorMsg && (
											<div
												className="alert alert-danger"
												role="alert"
											>
												<strong>Uh oh!</strong>
												{" " + this.state.errorMsg}
											</div>
										)}
										{this.state.successMsg && (
											<div
												className="alert alert-success"
											>
												<strong>Success!</strong>
												{" " + this.state.successMsg}
											</div>
										)}
									</form>
								</Modal>
							</div>
						</div>

						<div className="col-lg-6">
							<h2>
								{" "}
								Sign Up for a{" "}
								<strong>
									Kingston
									<span style={{ color: "#007D99" }}>
										Connect{" "}
									</span>
								</strong>{" "}
								Account
							</h2>
							<SignUp
								login={this.login}
								setLoading={this.setLoading}
								unsetLoading={this.unsetLoading}
							/>
						</div>
					</div>
				</div>
			);
		} else {
			return (
				<div className={styles.page}>
					<h1>
						{" "}
						<strong>
							Kingston
							<span style={{ color: "#007D99" }}>Connect</span>
						</strong>
					</h1>
					<h2>Welcome {this.state.employerName} </h2>
					<button
						className="btn btn-primary my-2"
						onClick={this.logOut}
					>
						{" "}
						Log Out{" "}
					</button>
					<h4>Please choose an option</h4>

					<div className={styles.buttonBox}>
						<div className="row justify-content-center">
							<div className="col-sm-9 p-3">
								<div className="card p-3 border-primary">
									<div className="card-body">
										<FontAwesomeIcon
											icon={faUsers}
											size="10x"
										/>
										<h4 className="card-text mb-3">
											Talent Pool
										</h4>
										<Link to="/kingstonconnect/view">
											<button
												type="button"
												className="btn btn-primary btn-lg"
											>
												View Talent Pool
											</button>
										</Link>
									</div>
								</div>
							</div>
						</div>
						<div className="row justify-content-center">
							<div className="col-sm-3">
								<div className="card bg-light">
									<div className="card-body">
										<FontAwesomeIcon
											icon={faAddressCard}
											size="5x"
										/>
										<p className="card-text">My Account</p>
										<Link to={"/kingstonconnect/manage"}>
											<button
												type="button"
												className="btn btn-primary"
											>
												Edit Account Details
											</button>
										</Link>
									</div>
								</div>
							</div>

							<div className="col-sm-3">
								<div className="card bg-light">
									<div className="card-body">
										<FontAwesomeIcon
											icon={faUserPlus}
											size="5x"
										/>
										<p className="card-text">
											Invite Talent
										</p>
										<Link to="/kingstonconnect/invite">
											<button
												type="button"
												className="btn btn-primary"
											>
												Send an Invitation
											</button>
										</Link>
									</div>
								</div>
							</div>

							<div className="col-sm-3">
								<div className="card bg-light">
									<div className="card-body">
										<FontAwesomeIcon
											icon={faUserTag}
											size="5x"
										/>
										<p className="card-text">My Invites</p>
										<Link to="/kingstonconnect/myinvites">
											<button
												type="button"
												className="btn btn-primary"
											>
												View My Invites
											</button>
										</Link>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			);
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/pages/KingstonConnect/KingstonConnect.js